module.exports = __webpack_public_path__ + "img/injective-2.cd4b7c60.webp";